<template>
  <div class="neighborViewEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.lab_closeNow')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_serviceType')" prop="serviceType">
          <el-radio-group v-model="ruleForm.serviceType" @change="changeType" :disabled="JSON.parse(this.isFlag)">
            <el-radio label="1">{{$t('lang.lab_good')}}</el-radio>
            <el-radio label="2">{{$t('lang.lab_activity')}}</el-radio>
            <el-radio label="3">{{$t('lang.lab_neigh')}}</el-radio>
          </el-radio-group>
        </el-form-item>        
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          
          <el-select v-if="this.isFlag"            
            class="single-select"
            v-model="ruleForm.gardenId"
            :placeholder="$t('lang.lab_selectCommunity')"
            @change="changeGarden"
            >
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-else
            class="multiple-select"
            v-model="ruleForm.gardenIds" 
            :placeholder="$t('lang.lab_selectCommunity')"
            multiple
            filterable
            clearable
            @change="change"
            >
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_serverName')" prop='goodName'>
          <el-input maxlength="20" style="width:50%" v-model="ruleForm.goodName" :placeholder="$t('lang.lab_serverName')">
          </el-input>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.serviceType == '1'?true:false" :label="$t('lang.lab_serverUrl')" prop='goodUrl'>
          <el-input maxlength="20" style="width:50%" v-model="ruleForm.goodUrl" :placeholder="$t('lang.lab_serverUrl')">
          </el-input>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.serviceType == '2'?true:false" :label="$t('lang.lab_selectActivity')" prop="activityId">
          <el-select v-model="ruleForm.activityId" class="select">
            <el-option
              v-for="(item,index) in activitys"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.serviceType == '3'?true:false" :label="$t('lang.lab_selectTab')" prop="tabId">
          <el-select v-model="ruleForm.tabId" class="select">
            <el-option
              v-for="(item,index) in tabs"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>        
        <el-form-item v-if='JSON.parse(this.isFlag)' :label="$t('lang.lab_image')" prop="goodImage" ref="goodImage">
          <el-upload ref="uploading" v-model="ruleForm.goodImage" class="upload-demo" name="files" :limit="1"
            accept=".jpg,.jpeg,.png" :on-success="handlePreviewedit" :on-error="uploadErr1"
            :action="require('@/config/enum').actionname" :on-exceed="handleExceed"
            :on-remove="handleRemove" list-type="picture-card" :file-list="fileList">
            <el-button size="small" type="primary">{{$t('lang.up_file')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.picture_tips')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item v-else :label="$t('lang.lab_uploadPhotograph')" prop="goodImage"
            ref="goodImage">
            <el-upload ref="uploading" v-model="ruleForm.goodImage" class="upload-demo" :limit="1"
              accept=".jpg,.jpeg,.png" :on-success="handlePreview" :on-error="uploadErr2"
              :action="require('@/config/enum').actionname" :on-exceed="handleExceed"
              :on-remove="handleRemove" name="files" list-type="picture-card">
                <el-button size="small" type="primary">{{$t('lang.up_file')}}</el-button>
                <div class="el-upload__tip" slot="tip">{{$t('lang.picture_tips')}}</div>
            </el-upload>
          </el-form-item>
        
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:neighborViewEdit
 *@Description:APP布局-编辑/新增
 *@author:李忠亮
 *@Copyright:格众科技
 *@date:2020-08-19
 */
export default {
  data() {
    return {
      saveData: '',
      id: '', // id
      oldsearchUnit: [], // 复选输入框change前的数据
      index: '', // 复选的小区序号
      fileList: [{
                    name: '',
                    url: ''
                }], // 文件列表
      ruleForm: {
        serviceType: '', // 服务类型
        goodName: '', // 服务名称
        goodUrl: '', // 服务URL
        goodImage: '', // 图片链接
        fileList: [], // 上传文件集合
        activityId: '', // 活动ID
        gardenId: '', // 小区ID
        gardenIds: '', // 小区IDs
        tabId: '' // 帖子ID
      },
      rules: {
        serviceType: [{ required: true, message: this.$i18n.t('lang.lab_pleaseContent'), trigger: 'blur' }],
        goodName: [{ required: true, message: this.$i18n.t('lang.lab_pleaseContent'), trigger: 'blur' }],
        goodUrl: [{ required: true, message: this.$i18n.t('lang.lab_checkServerUrl'), trigger: 'blur' }],
        activityId: [{ required: true, message: this.$i18n.t('lang.lab_checkActivity'), trigger: 'blur' }],
        tabId: [{ required: true, message: this.$i18n.t('lang.lab_checkTab'), trigger: 'blur' }],
        goodImage: [{
                        required: true,
                        message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
                        trigger: 'change'
                    }],
      },
      gardenId: '', // 小区
      gardens: [], // 小区集合
      garden: [], // 所选小区
      tabs: [], // 帖子集合
      activitys: [], // 活动集合
      isDisabled: true, // 保存的可点击
      isFlag: 'false', // 编辑:true 新增：false
      options: this.$i18n.t('lang.optionsModule'),
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
    }
  },
  destroyed() {
    window.localStorage.setItem('appletsGoodForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('appletsGoodSaveData', JSON.stringify(this.saveData))
  },
  created() {
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
    if (window.localStorage.getItem('appletsGoodForm')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('appletsGoodForm'))
        if (this.ruleForm.gardenId) {
          this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
        }
       if (window.localStorage.getItem('appletsGoodSaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('appletsGoodSaveData'))
        }  
      if (this.isFlag == true) {
        this.id = this.$route.query.id
        this.getData()
        this.getActivitys(this.$route.query.gardenId)     
      } else {
        this.selectGarden()
      }
      this.myGarden()
      this.getTabs()
    } else {
      if (this.isFlag == true) {
        this.id = this.$route.query.id
        this.getData()
        this.getActivitys(this.$route.query.gardenId)     
      } else {
      this.selectGarden()
      }
      this.myGarden()
      this.getTabs()
    }    
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 上传文件的断网
            uploadErr1() {
                if (!navigator.onLine || window.navigator.onLine === false) {
                    const loading = this.$loading()
                    setTimeout(() => {
                    loading.close()
                    this.$message.error(this.$i18n.t('lang.lab_Online'))
                    }, 500)
                }
            },
            // 上传文件的断网
            uploadErr2() {
                if (!navigator.onLine || window.navigator.onLine === false) {
                    const loading = this.$loading()
                    setTimeout(() => {
                    loading.close()
                    this.$message.error(this.$i18n.t('lang.lab_Online'))
                    }, 500)
                }
            },
            // 修改时图片函数
            handlePreviewedit(file) {
                this.ruleForm.goodImage = file.data[0]
                this.$refs.goodImage.clearValidate()
            },
            // 移除图片
            handleRemove() {
                console.log('进入移除')
                this.ruleForm.fileList = []
                this.ruleForm.goodImage = ''
                this.ruleForm.image = ''
            },
            // 超出个数的钩子(之前是on-change方法，现在是on-exceed方法)
            handleExceed(files, fileList) {
                this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
            },
            upload(item) {
                this.ruleForm.image = item.file
            },
            handlePreview(response, file, fileList) {
                this.ruleForm.goodImage = file.response.data[0]
                this.ruleForm.fileList = fileList
                this.$refs.goodImage.clearValidate()
            },
            handleChange(value) {
                console.log(value)
            },
    // 编辑页图片直接替换
    checkEdit() {
      if (this.id != '') {
        this.fileList = []
      }
    },
    // 小区下拉
    myGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
    },
    // 小区下拉
    selectGarden() {
      this.$get(`/gardens`).then(
        res => {
          if (res && res.errCode === 0) {
            this.gardens = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取帖子List
    getTabs() {
      this.$get(`tab?pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            this.tabs = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取活动List
    getActivitys(val) {
      this.$get(`activity?keyword=isClose&gardenId=` + val).then(
        res => {
          if (res && res.errCode === 0) {
            this.activitys = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // id查询详情
    getData() {
      let loading = this.$loading()
      this.$get(`/appletsGoodById/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.ruleForm = res.appletsGood
            this.ruleForm.serviceType = this.ruleForm.serviceType.toString()
            this.fileList[0].url = this.ruleForm.goodImage
            // gardenId字符串转数字值
            this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 保存
    save(formName) {
      if (this.isFlag === false) {
        // 验证所属小区是否为空
        if (this.ruleForm.gardenIds.length === 0) {
          this.$message.error(this.$i18n.t('lang.lab_selectOneVillage'))
          return
        }
        // 删除数组中的全选"0"
        if (this.ruleForm.gardenIds.includes(0)) {
          this.ruleForm.gardenIds.splice(0, 1)
        }
      }
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          if (this.isFlag) {
            let params = {
              'garden[]': this.ruleForm.gardenId,
              'tabsId': this.ruleForm.tabId,
              'ActivityId': this.ruleForm.activityId,
              'GoodName': this.ruleForm.goodName,
              'GoodUrl': this.ruleForm.goodUrl,
              'ServiceType': this.ruleForm.serviceType,
              'GoodImage': this.ruleForm.goodImage
            }
            this.$patch(`/appletsGood/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_modify_success'))
                  var index = this.$keepAlive.indexOf('/manage/main.appletsGoodList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'appletsGoodList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = { 
              'garden[]': this.ruleForm.gardenIds.toString(),
              'tabsId': this.ruleForm.tabId,
              'ActivityId': this.ruleForm.activityId,
              'GoodName': this.ruleForm.goodName,
              'GoodUrl': this.ruleForm.goodUrl,
              'ServiceType': this.ruleForm.serviceType,
              'GoodImage': this.ruleForm.goodImage
            }
            this.$post(`/appletsGood`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  var index = this.$keepAlive.indexOf('/manage/main.appletsGoodList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'appletsGoodList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    // 返回
    back() {
      this.$router.push({ name: 'appletsGoodList' })
    },
    // 清空
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.orderBy = '' // 排序
      this.ruleForm.appModule = '' // 模块
      if (this.isFlag === false) {
        this.ruleForm.gardenIds = ''
      }
    },
    // 图片上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log('Upload Success!', file, fileList)
      this.ruleForm.image = file.response.data[0]
    },
    // 上传
    submitUpload() {
      this.$refs.upload.submit()
    },
    // 多选项
    change(val) {      
      const allValues = []
      // 将全选"0"加入allValues
      allValues.push(0)
      for (const item of this.gardens) {
        allValues.push(item.id)
      }
      // 用来储存上一次选择的值，可进行对比
      const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
      // 若选择全部
      if (val.includes(0)) {
        this.ruleForm.gardenIds = allValues
      }
      // 取消全部选中， 上次有， 当前没有， 表示取消全选
      if (oldVal.includes(0) && !val.includes(0)) {
        this.ruleForm.gardenIds = []
      }
      // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
      if (oldVal.includes(0) && val.includes(0)) {
        const index = val.indexOf(0)
        val.splice(index, 1)
        this.ruleForm.gardenIds = val
      }
      // 全选未选，但是其他选项都全部选上了，则全选选上
      if (!oldVal.includes(0) && !val.includes(0)) {
        if (val.length === allValues.length - 1) {
          this.ruleForm.gardenIds = [0].concat(val)
        }
      }
      // 储存当前选择的最后结果 作为下次的老数据
      this.oldsearchUnit[0] = this.ruleForm.gardenIds
      // 活动联动
      if (this.ruleForm.serviceType == 2) {
        if (this.isFlag === false) {
          this.ruleForm.activityId = ''
          this.activitys = []
          if (this.ruleForm.gardenIds.length == 1) {
            this.getActivitys(this.ruleForm.gardenIds)
          } else if ((this.ruleForm.gardenIds.length == 0)) {
            this.$message.warning(this.$i18n.t('lang.reportPleaseSelectVillage'))
          } else {
            this.$message.error(this.$i18n.t('lang.lab_checkGardenCount'))
            this.ruleForm.gardenIds = ''
          }
        }
      }
    },
    changeGarden(val) {
      // 活动联动
      if (this.ruleForm.serviceType == 2) {
        this.ruleForm.activityId = ''
        this.activitys = []
        this.getActivitys(this.ruleForm.gardenId)
      }
    },
    // 类型变更
    changeType(val) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.gardenIds = ''
      this.ruleForm.gardenId = ''
      this.ruleForm.goodUrl = ''
      this.ruleForm.tabId = ''
      this.ruleForm.activityId = ''
      this.activitys = []      
    },
  }
}
</script>

<style lang="scss">
.neighborViewEdit {
  .single-select {
    width: 30%;
  }
  .multiple-select {
    width: 50%;
  }
  .input-width{
    width: 60%;
  }
  .img {
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
}
</style>